import ButtonGroup from "./ButtonGroup.jsx";

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analysis/buttonGroup/index.js